import script from "./SignupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupPage.vue?vue&type=script&setup=true&lang=js"

import "./SignupPage.vue?vue&type=style&index=0&id=3e330d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e330d9c"]])

export default __exports__